import React, { ReactNode } from "react"
import styled, { css } from "styled-components"

import { Box } from "components/box"
import { Paragraph, Link } from "components/text"
import ArrowRight from "assets/icons/arrow-right.svg"

const Content = styled(Paragraph)`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

const CONTAINER_CSS = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  background-color: ${props => props.theme.colors.sandy};
  color: ${props => props.theme.colors.evergreen};
  text-align: center;

  :hover {
    opacity: 1;
    svg {
      transform: translateX(${props => props.theme.space[2]});
    }
    ${Content} {
      opacity: ${props => props.theme.reducedOpacity};
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}px) {
    flex-direction: row;
    justify-content: space-between;
  }
`

const LinkContainer = styled(Link).attrs({
  py: 4,
  px: 5,
  mt: [5, 5, 7, 7],
  mb: [3, 3, 5, 5]
})`
  ${CONTAINER_CSS}
`

const BoxContainer = styled(Box).attrs({
  py: 4,
  px: 5,
  mt: [5, 5, 7, 7],
  mb: [3, 3, 5, 5]
})`
  ${CONTAINER_CSS}
  text-decoration: none;
`

const Description = styled(Paragraph).attrs({
  mr: [0, 3],
  mb: [4, 0],
  textAlign: ["center", "left"]
})``

type NotificationLinkProps = {
  to: string
  description: ReactNode
  dataTest?: string
}

type NotificationBoxProps = {
  description: ReactNode
  dataTest?: string
} & React.HTMLProps<HTMLDivElement>

export const NotificationLink: React.FC<NotificationLinkProps> = ({ to, description, dataTest, children }) => (
  <LinkContainer to={to} data-test={dataTest}>
    <Description>{description}</Description>
    <Content bold>
      {children}
      <ArrowRight />
    </Content>
  </LinkContainer>
)

export const NotificationBox: React.FC<NotificationBoxProps> = ({ description, onClick, dataTest, children }) => (
  <BoxContainer onClick={onClick} data-test={dataTest}>
    <Description>{description}</Description>
    <Content bold>
      {children}
      <ArrowRight />
    </Content>
  </BoxContainer>
)
